import { trackEvent } from '../../services/analytics';
import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { signInWithFlutterWebLoginToken } from '../../services/firebaseData';

export default function FlutterWebLoginPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;

    async function run() {
      const token = searchParams.get('token');
      const redirectTo = searchParams.get('redirectTo') || '/index';

      try {
        await signInWithFlutterWebLoginToken(token);
        trackEvent('login', { method: 'native' });

        if (!active) return;

        navigate(redirectTo, { replace: true });
      } catch (err) {
        console.error('Unable to sign in with Flutter WebView token:', err);

        if (!active) return;

        setError(err?.message || 'Unable to sign in');
      }
    }

    run();

    return () => {
      active = false;
    };
  }, [navigate, searchParams]);

  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'grid',
        placeItems: 'center',
        p: 3,
        textAlign: 'center',
      }}
    >
      {error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <Box>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>
            Accesso in corso...
          </Typography>
        </Box>
      )}
    </Box>
  );
}